module.exports = __webpack_public_path__ + "static/media/pinksale.a7daad42.png";